<template>
	<v-hover
		v-slot="{ hover }"

	>
		<v-card
			style="cursor: pointer"
			:elevation="hover ? 16 : 2"
			class="mx-auto my-3"
			max-width="800"
			tile

			@click.native="onSelected"
		>
			<v-card-text class="p-0">
				<v-row align="center">
					<v-col>
						<v-list-item three-line>
							<v-list-item-content>
								<v-list-item-title><h1>{{ cPackage.title }}</h1></v-list-item-title>
								<v-list-item-content class="text-center">
									{{ cPackage.subtitle }}
								</v-list-item-content>
								<v-list-item-content class="justify-center mt-5">
									<div style="direction: ltr">
										<span>{{ price }}&#8362;</span>
										<span v-if="numOfPayments >1"> X </span>
										<span v-if="numOfPayments >1">{{ numOfPayments }}</span>
									</div>
								</v-list-item-content>
							</v-list-item-content>
						</v-list-item>
					</v-col>

				</v-row>
			</v-card-text>

		</v-card>
	</v-hover>
</template>

<script>
	export default {
		name: "package-card",
		props: {cPackage: Object,payments:Number},
		methods: {
			onSelected(selected) {
				this.$emit("selected", this.cPackage);
			}
		}, computed: {
			numOfPayments(){
				return this.payments || this.cPackage.num_of_payments;
			},
			price() {
				let numOfPayments = this.numOfPayments;
				if (this.cPackage.price % numOfPayments)
					return (this.cPackage.price / numOfPayments).toFixed(1);
				return (this.cPackage.price / numOfPayments);

			}
		}
	};
</script>

<style scoped>

</style>
